export default __webpack_public_path__ + "static/timeportals1-7e4f7b808675c1f808279c645a4e0bf3.png";